import { Badge } from '@/client/components/ui/badge';

const STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  completed: 'Completed',
  on_hold: 'On Hold',
};

function statusVariant(status: string): 'default' | 'secondary' | 'outline' {
  if (status === 'active') return 'default';
  if (status === 'completed') return 'secondary';
  return 'outline';
}

interface ProjectRowProps {
  project: { id: string; name: string; status: string; client_name: string | null };
  isLast: boolean;
  compact?: boolean;
}

export function ProjectRow({ project: p, isLast, compact = false }: ProjectRowProps) {
  const monogramSize = compact ? 'h-8 w-8 text-xs' : 'h-9 w-9 text-sm';
  const padding = compact ? 'px-5 py-3.5' : 'px-5 py-4';
  return (
    <div className={`flex items-center gap-3 ${padding} ${isLast ? '' : 'border-b'}`}>
      <div
        className={`flex ${monogramSize} shrink-0 items-center justify-center rounded-lg bg-muted font-semibold`}
      >
        {p.name
          .split(' ')
          .map((s) => s[0])
          .join('')
          .slice(0, 2)
          .toUpperCase()}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium">{p.name}</p>
        {p.client_name && <p className="truncate text-xs text-muted-foreground">{p.client_name}</p>}
      </div>
      <Badge variant={statusVariant(p.status)} className="shrink-0">
        {STATUS_LABELS[p.status] ?? p.status}
      </Badge>
    </div>
  );
}
